import {
  Add,
  ArrowBack,
  Cancel,
  CheckCircle,
  ContentCopy,
  Delete,
  Edit,
  Save,
  Send,
  SwapHoriz,
} from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/material";

const actionConfig = [
  {
    key: "submit",
    fallbackText: "Οριστική Υποβολή",
    icon: <Send />,
    variant: "contained",
  },
  {
    key: "saveReview",
    fallbackText: "Αποθήκευση",
    icon: <Save />,
    variant: "outlined",
  },
  {
    key: "review",
    fallbackText: "Έλεγχος",
    icon: <CheckCircle />,
    variant: "contained",
  },
  {
    key: "approve",
    fallbackText: "Έγκριση",
    icon: <CheckCircle />,
    variant: "contained",
    color: "success",
  },
  {
    key: "reject",
    fallbackText: "Απόρριψη",
    icon: <Cancel />,
    variant: "contained",
    color: "error",
  },
  {
    key: "return",
    fallbackText: "Επιστροφή στο Φορέα",
    icon: <SwapHoriz />,
    variant: "contained",
    color: "warning",
  },
  {
    key: "cancel",
    fallbackText: "Ακύρωση",
    icon: <Cancel />,
    variant: "contained",
    color: "error",
  },
  {
    key: "changeStatus",
    fallbackText: "Αλλαγή Κατάστασης",
    icon: <SwapHoriz />,
    variant: "outlined",
  },
  {
    key: "editHeader",
    fallbackText: "Επεξεργασία Στοιχείων",
    icon: <Edit />,
    variant: "outlined",
  },
  {
    key: "addExpense",
    fallbackText: "Ανάλυση Δαπάνης",
    icon: <Add />,
    variant: "outlined",
  },
  {
    key: "delete",
    fallbackText: "Διαγραφή",
    icon: <Delete />,
    variant: "outlined",
    color: "error",
  },
];

const getActionSetting = (settings, key) => {
  if (key === "delete") {
    if (settings?.delete) return settings.delete;
    if (settings?.canDelete === true) return { can: true };
  }

  return settings?.[key];
};

const getActionText = (action) => {
  if (action.key === "saveReview" && action.setting?.txt === "Save Review") {
    return action.fallbackText;
  }

  return action.setting?.txt ?? action.fallbackText;
};

const ExpenseActions = ({
  settings,
  disabled = false,
  disabledActions = [],
  onAction,
  onBack,
  canCopyReview = false,
  onCopyReview,
}) => {
  const visibleActions = actionConfig
    .filter((action) => !["editHeader", "addExpense", "review"].includes(action.key))
    .map((action) => ({
      ...action,
      setting: getActionSetting(settings, action.key),
    }))
    .filter((action) => action.setting?.can === true);

  if (visibleActions.length === 0 && !onBack && !canCopyReview) return null;

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "0.25rem",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
        px: 1,
        py: 1,
      }}
    >
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {onBack && (
          <Button
            size="small"
            color="secondary"
            variant="contained"
            startIcon={<ArrowBack />}
            onClick={onBack}
            sx={{
              color: "#fefefe",
              fontWeight: 800,
              minHeight: 32,
              whiteSpace: "nowrap",
              "&:hover": {
                color: "#fefefe",
              },
            }}
          >
            Επιστροφή στις Δαπάνες
          </Button>
        )}
        {visibleActions.map((action) => {
          const actionText = getActionText(action);
          const isActionDisabled =
            disabled || disabledActions.includes(action.key);

          return (
            <Button
              key={action.key}
              size="small"
              color={action.color ?? "primary"}
              variant={action.variant}
              startIcon={action.icon}
              disabled={isActionDisabled}
              onClick={() => onAction?.(action.key, action.setting)}
              title={
                action.key === "addExpense"
                  ? `${actionText} (Alt+N)`
                  : undefined
              }
              sx={{
                fontWeight: 800,
                minHeight: 32,
                whiteSpace: "nowrap",
              }}
            >
              {actionText}
            </Button>
          );
        })}
        {canCopyReview && (
          <Button
            size="small"
            color="primary"
            variant="outlined"
            startIcon={<ContentCopy />}
            disabled={disabled}
            onClick={onCopyReview}
            sx={{
              fontWeight: 800,
              minHeight: 32,
              whiteSpace: "nowrap",
            }}
          >
            Αντιγραφή Σύνοψης Ελέγχου
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ExpenseActions;
